export const paymentSearchBoxInfo = {
  title: "검색",
  fields: [
    {
      size: 20,
      label: "납부일(시작)",
      type: "datepicker",
    },
    {
      size: 20,
      label: "납부일(끝)",
      type: "datepicker",
    },
  ],
};

export const donationFormInfo = {
  payerName: {
    size: 50,
    label: "label.payer_name",
    type: "text",
    icon: "badge",
    rules: "required"
  },
  payerEmail: {
    size: 50,
    label: "label.payer_email",
    type: "text",
    icon: "mail",
    rules: "required|email"
  },
  memo: {
    size: 50,
    label: "label.memo",
    type: "text",
    icon: "edit_note",
  },
  amount: {
    size: 50,
    label: "label.amount",
    type: "text",
    icon: "money",
    rules: "required|numeric"
  },
  currency_code: {
    size: 50,
    label: "label.currency",
    type: "select",
    icon: "price_check",
    // options: ["USD", "KRW"],
    options: ["USD"],
    rules: "required",
  },
};
